import { h } from '../../../../src/shared/components/dom.js';
import { FACET_LABELS, LISTED_TYPES, UNOFFICIAL_TYPES, UNOFFICIAL_GROUP_LABEL } from '../../../../src/shared/release-type-vocabulary.js';
import { sanitizeReleaseTypes } from '../browse-state.js';

let nextFacetId = 0;

/** The sidebar owns persistence; this component only reports ordered selections. */
export function ReleaseTypeFacet({ selection, onChange }) {
  const selected = sanitizeReleaseTypes(selection);
  const instance = ++nextFacetId;
  const headingId = `lib-release-heading-${instance}`;
  const groupId = `lib-release-unofficial-${instance}`;
  const childIds = UNOFFICIAL_TYPES.map(type => `lib-release-${type}-${instance}`);
  const selectedChildren = UNOFFICIAL_TYPES.filter(type => selected.includes(type));
  const groupState = selectedChildren.length === UNOFFICIAL_TYPES.length ? 'true'
    : selectedChildren.length ? 'mixed' : 'false';

  function checkbox(type, label, checked, activate, props = {}) {
    return h('button', {
      type: 'button',
      class: `lib-release-choice${checked === 'true' ? ' active' : ''}`,
      role: 'checkbox',
      'aria-checked': checked,
      'data-release-control': type,
      onclick: activate,
      ...props,
    },
      h('span', { class: 'lib-release-choice-box', 'aria-hidden': 'true' },
        checked === 'true' ? '✓' : checked === 'mixed' ? '−' : ''),
      h('span', { class: 'lib-release-choice-label' }, label),
    );
  }

  const official = checkbox('official', FACET_LABELS.official,
    selected.includes('official') ? 'true' : 'false', () => {
      const next = selected.includes('official')
        ? selected.filter(type => type !== 'official') : [...selected, 'official'];
      onChange(LISTED_TYPES.filter(type => next.includes(type)), 'official');
    });
  const group = checkbox('unofficial', UNOFFICIAL_GROUP_LABEL, groupState, () => {
    const next = groupState === 'true'
      ? selected.filter(type => !UNOFFICIAL_TYPES.includes(type))
      : LISTED_TYPES.filter(type => selected.includes(type) || UNOFFICIAL_TYPES.includes(type));
    onChange(next, 'unofficial');
  }, { id: groupId, 'aria-controls': childIds.join(' ') });
  const children = h('div', {
    class: 'lib-release-children', role: 'group', 'aria-labelledby': groupId,
  }, ...UNOFFICIAL_TYPES.map((type, index) => checkbox(
    type, FACET_LABELS[type], selected.includes(type) ? 'true' : 'false', () => {
      const next = selected.includes(type)
        ? selected.filter(value => value !== type) : [...selected, type];
      onChange(LISTED_TYPES.filter(value => next.includes(value)), type);
    }, { id: childIds[index] },
  )));

  return h('section', {
    class: 'lib-sidebar-section lib-release-facet', role: 'group', 'aria-labelledby': headingId,
  },
    h('h2', { class: 'lib-sidebar-heading', id: headingId }, 'Release type'),
    official, group, children,
  );
}
